import { render, staticRenderFns } from "./IconTeam.vue?vue&type=template&id=16485259"
import script from "./IconTeam.vue?vue&type=script&lang=js"
export * from "./IconTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports